<script setup>
import { useAuth0 } from "@auth0/auth0-vue";
import WeatherWidget from "../components/WeatherWidget.vue";
import TimeWidget from "../components/TimeWidget.vue";
import NewsWidget from "../components/NewsWidget.vue";
import UserWidget from "../components/UserWidget.vue";

const { logout, user, isAuthenticated } = useAuth0();
const handleLogout = () => {
  logout({ logoutParams: { returnTo: window.location.origin } });
};
</script>

<template>
  <div class="grid-x full-width">
    <div class="cell small-12 medium-offset-1 medium-10 large-offset-1 large-10 white-section content-section">
      <div class="grid-x">
        <div class="cell medium-3 show-for-medium-only"></div>
        <!-- Look into push/pull-->
        <div class="cell small-12 medium-6 large-3">
          <UserWidget :user="user" @logout="handleLogout"></UserWidget>
        </div>

        <div class="cell small-12 medium-12 large-9">
          <div class="main-content">
            <h2 class="left-align">Hi {{ user.meta_firstname }} | Profile</h2>

            <p>
              Welcome to your personal dashboard. Your central hub for staying connected to what matters around you.
              Designed to bring essential everyday information together in one place, this space automatically adapts to
              your location to keep you informed with minimal effort.
            </p>
            <p>
              Whether you're checking the local weather forecast before heading out, confirming accurate local time zone
              details, or skimming the latest regional headlines, everything is structured for quick, clear reading.
              Explore your widgets below to get a real-time snapshot of your day.
            </p>

            <h3 class="left-align">Local information</h3>

            <div class="grid-x">
              <div class="cell small-12 medium-offset-3 medium-6 large-offset-0 large-4 margin-bottom card-padding">
                <TimeWidget :user-location="user.meta_location.address_line2"></TimeWidget>
              </div>
              <div class="cell small-12 medium-offset-3 medium-6 large-4 large-offset-0 margin-bottom card-padding">
                <WeatherWidget :user-location="user.meta_location.address_line2"></WeatherWidget>
              </div>
              <div class="cell small-12 medium-offset-3 medium-6 large-offset-0  large-4 margin-bottom card-padding">
                <NewsWidget :user-location="user.meta_location.address_line2"></NewsWidget>
              </div>
            </div>


            <h3 class="left-align">Your diary</h3>
            <p>
              All of your diary information will be available soon.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
@import "../assets/styles/profile.scss";
</style>
